// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/password_push/v1/password_push_flow_search.proto" (package "c1.api.password_push.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { PasswordPushFlow } from "./password_push_flow";
// ====== Messages ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowRef
 */
export interface PasswordPushFlowRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
// ====== Search ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowSearchServiceSearchRequest
 */
export interface PasswordPushFlowSearchServiceSearchRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.password_push.v1.PasswordPushFlowRef refs = 3
     */
    refs: PasswordPushFlowRef[];
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowSearchServiceSearchResponse
 */
export interface PasswordPushFlowSearchServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.password_push.v1.PasswordPushFlow list = 1
     */
    list: PasswordPushFlow[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.SearchAvailablePasswordPushFlowsForUserRequest
 */
export interface SearchAvailablePasswordPushFlowsForUserRequest {
    /**
     * @generated from protobuf field: string user_id = 1
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.SearchAvailablePasswordPushFlowsForUserResponse
 */
export interface SearchAvailablePasswordPushFlowsForUserResponse {
    /**
     * @generated from protobuf field: repeated c1.api.password_push.v1.PasswordPushFlow list = 1
     */
    list: PasswordPushFlow[];
}
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowRef$Type extends MessageType<PasswordPushFlowRef> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<PasswordPushFlowRef>): PasswordPushFlowRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPushFlowRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushFlowRef): PasswordPushFlowRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushFlowRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowRef
 */
export const PasswordPushFlowRef = new PasswordPushFlowRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowSearchServiceSearchRequest$Type extends MessageType<PasswordPushFlowSearchServiceSearchRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowSearchServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PasswordPushFlowRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
    create(value?: PartialMessage<PasswordPushFlowSearchServiceSearchRequest>): PasswordPushFlowSearchServiceSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<PasswordPushFlowSearchServiceSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushFlowSearchServiceSearchRequest): PasswordPushFlowSearchServiceSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* repeated c1.api.password_push.v1.PasswordPushFlowRef refs */ 3:
                    message.refs.push(PasswordPushFlowRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushFlowSearchServiceSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* repeated c1.api.password_push.v1.PasswordPushFlowRef refs = 3; */
        for (let i = 0; i < message.refs.length; i++)
            PasswordPushFlowRef.internalBinaryWrite(message.refs[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowSearchServiceSearchRequest
 */
export const PasswordPushFlowSearchServiceSearchRequest = new PasswordPushFlowSearchServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowSearchServiceSearchResponse$Type extends MessageType<PasswordPushFlowSearchServiceSearchResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowSearchServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PasswordPushFlow },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PasswordPushFlowSearchServiceSearchResponse>): PasswordPushFlowSearchServiceSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPushFlowSearchServiceSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushFlowSearchServiceSearchResponse): PasswordPushFlowSearchServiceSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.password_push.v1.PasswordPushFlow list */ 1:
                    message.list.push(PasswordPushFlow.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushFlowSearchServiceSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.password_push.v1.PasswordPushFlow list = 1; */
        for (let i = 0; i < message.list.length; i++)
            PasswordPushFlow.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowSearchServiceSearchResponse
 */
export const PasswordPushFlowSearchServiceSearchResponse = new PasswordPushFlowSearchServiceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAvailablePasswordPushFlowsForUserRequest$Type extends MessageType<SearchAvailablePasswordPushFlowsForUserRequest> {
    constructor() {
        super("c1.api.password_push.v1.SearchAvailablePasswordPushFlowsForUserRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<SearchAvailablePasswordPushFlowsForUserRequest>): SearchAvailablePasswordPushFlowsForUserRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAvailablePasswordPushFlowsForUserRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAvailablePasswordPushFlowsForUserRequest): SearchAvailablePasswordPushFlowsForUserRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAvailablePasswordPushFlowsForUserRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.SearchAvailablePasswordPushFlowsForUserRequest
 */
export const SearchAvailablePasswordPushFlowsForUserRequest = new SearchAvailablePasswordPushFlowsForUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAvailablePasswordPushFlowsForUserResponse$Type extends MessageType<SearchAvailablePasswordPushFlowsForUserResponse> {
    constructor() {
        super("c1.api.password_push.v1.SearchAvailablePasswordPushFlowsForUserResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PasswordPushFlow }
        ]);
    }
    create(value?: PartialMessage<SearchAvailablePasswordPushFlowsForUserResponse>): SearchAvailablePasswordPushFlowsForUserResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAvailablePasswordPushFlowsForUserResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAvailablePasswordPushFlowsForUserResponse): SearchAvailablePasswordPushFlowsForUserResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.password_push.v1.PasswordPushFlow list */ 1:
                    message.list.push(PasswordPushFlow.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAvailablePasswordPushFlowsForUserResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.password_push.v1.PasswordPushFlow list = 1; */
        for (let i = 0; i < message.list.length; i++)
            PasswordPushFlow.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.SearchAvailablePasswordPushFlowsForUserResponse
 */
export const SearchAvailablePasswordPushFlowsForUserResponse = new SearchAvailablePasswordPushFlowsForUserResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.password_push.v1.PasswordPushFlowSearchService
 */
export const PasswordPushFlowSearchService = new ServiceType("c1.api.password_push.v1.PasswordPushFlowSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: PasswordPushFlowSearchServiceSearchRequest, O: PasswordPushFlowSearchServiceSearchResponse },
    { name: "SearchAvailablePasswordPushFlowsForUser", options: { "authz.method": { role: "VIEWER" } }, I: SearchAvailablePasswordPushFlowsForUserRequest, O: SearchAvailablePasswordPushFlowsForUserResponse }
]);
